// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShzG4CEl","assetTicker":"B6nvAtLg","assetWrapper":"MRs0LYMn"};